export const downloadFile = (fileUrl, filename, shouldCleanupUrl = false) => {
  const link = document.createElement("a");
  link.href = fileUrl;

  if (filename) {
    link.download = filename;
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (shouldCleanupUrl) {
    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
  }
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  downloadFile(url, filename, true);
};
